import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import { FaRegEdit, FaRegTrashAlt, FaArrowLeft } from "react-icons/fa";
// import HorizontalScroll from 'react-horizontal-scrolling'
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
function Unit() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;
  const scroll = {
    height: "600px",
    overflowY: "scroll",
  };

  const [medicineLists, setMedicineLists] = useState([]);
  const [unitLists, setUnitLists] = useState([]);
  const [opacity, setOpacity] = useState(false);
  const [status, setStatus] = useState("UnCheck");
  const [medShowName, setMedShowName] = useState("");
  const [proShowName, setProShowName] = useState("");
  const [accShowName, setAccShowName] = useState("");
  const [genShowName, setGenShowName] = useState("");
  // console.log(toShowName, "toshow");

  // const [medicineListName, setMedicineListname] = useState('');
  const medicineListId = useLocation().pathname.split("/")[2];

  useEffect(() => {
    const getMedicineLists = async () => {
      try {
        const res = await api.get("purchase-request/" + medicineListId);

        const myArray = [res.data.data];
        // console.log(
        //   (myArray[0].relatedApprove.medicineItems[0]
        //     ? myArray[0].relatedApprove.medicineItems
        //     : "") ||
        //     (myArray[0].relatedApprove.procedureItems[0]
        //       ? myArray[0].relatedApprove.procedureItems
        //       : ""),
        //   "med"
        // );
        setMedShowName(myArray[0].relatedApprove.medicineItems.length);
        setProShowName(myArray[0].relatedApprove.procedureItems.length);
        setAccShowName(myArray[0].relatedApprove.accessoryItems.length);
        setGenShowName(myArray[0].relatedApprove.generalItems.length);
        setMedicineLists(
          (myArray[0].relatedApprove.medicineItems[0]
            ? myArray[0].relatedApprove.medicineItems
            : "") ||
            (myArray[0].relatedApprove.procedureItems[0]
              ? myArray[0].relatedApprove.procedureItems
              : "") ||
            (myArray[0].relatedApprove.accessoryItems[0]
              ? myArray[0].relatedApprove.accessoryItems
              : "") ||
            (myArray[0].relatedApprove.generalItems[0]
              ? myArray[0].relatedApprove.generalItems
              : ""),
        );
      } catch (err) {
        alert(err.message);
      }
    };

    getMedicineLists();
  }, []);
  const handleOK = (index) => {
    console.log(medicineLists.filter((el, i) => el._id === index));
    if (medicineLists.filter((el, i) => el._id === index)) {
      setMedicineLists(medicineLists.filter((el, i) => el._id === index));
      setOpacity(true);
    }

    setStatus("Checked");
  };
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/expDateList">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      style={{ marginTop: "0.2em" }}
                    >
                      <i className="text-lg">
                        {console.log(accShowName, "Leee", "ttotoo")}
                        {(medShowName !== 0 && "Medicine") ||
                          (proShowName !== 0 && "Procedure") ||
                          (accShowName !== 0 && "Accessory") ||
                          (genShowName !== 0 && "General")}
                        &nbsp; Item Expeired Date List
                      </i>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header fs-5">
                      {/* {medicineLists}'s Unit */}
                    </div>
                    <div className="card-body bg-light">
                      <div style={scroll}>
                        <table id="" className="table">
                          <thead className="sticky-top bg-light">
                            <tr>
                              <th>No</th>
                              <th>Expired Date</th>
                              <th>Code</th>
                              <th>Name</th>
                              <th>Purchase Qty</th>
                              <th>Total Price</th>

                              {/* <th>Unit</th> */}
                              <th>Desc</th>
                              <th>Unit</th>
                              {/* <th>Action</th> */}
                            </tr>
                          </thead>
                          {/* {console.log(medicineLists, "list med")} */}
                          {medicineLists.map((unit, i) => (
                            <tbody>
                              <tr>
                                <td>{++i}</td>
                                <td className="text-red ">
                                  {unit.expiredDate?.split("T")[0]}
                                </td>
                                <td>{unit.item_id.code}</td>
                                <td>
                                  {unit.item_id.medicineItemName ||
                                    unit.item_id.procedureItemName ||
                                    unit.item_id.accessoryItemName ||
                                    unit.item_id.generalItemName}
                                </td>
                                <td>
                                  {unit.transferQty ? unit.transferQty : "0"}
                                </td>
                                <td>{unit.subTotal}</td>

                                <td>{unit.item_id?.description}</td>
                                <td>{unit.item_id?.unit}</td>
                                {/* <td className=''>
                                  {opacity ? (
                                    <button
                                      className='btn btn-sm btn-warning'
                                      onClick={() => handleOK(unit._id)}
                                      disabled
                                    >
                                      OK
                                    </button>
                                  ) : (
                                    <button
                                      className='btn btn-sm btn-warning'
                                      onClick={() => handleOK(unit._id)}
                                    >
                                      OK
                                    </button>
                                  )}
                                </td> */}
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

    </>
  );
}
export default Unit;
